import { BadgeCheck } from 'lucide-react';
import React from 'react';

export const CommonServicePage = ({ currentService }) => {
  return (
    <div className="mt-[9rem] flex w-full justify-center bg-[white] py-[4rem] font-inter">
      <div className="flex w-full max-w-[144rem] flex-row flex-wrap items-stretch justify-center gap-x-[1rem] gap-y-[3rem] px-[2rem]">
        {/* Hero Section */}
        <div className="flex w-full justify-center">
          <BadgeCheck className="h-auto w-[8rem] text-[#e24e1f]" />
        </div>
        <div className="mb-[4rem] text-center">
          <h1 className="hidden text-[3.2rem] font-[700] leading-[4rem] text-[#121212] md:block lg:text-[4rem] lg:leading-[5.5rem]">
            {currentService.mainHeader}
          </h1>
          <h1 className="text-center text-[2.4rem] font-[700] leading-[3.2rem] text-[#121212] md:hidden lg:text-[4rem] lg:leading-[5.5rem]">
            {currentService.mainHeader}
          </h1>

          <p className="mx-auto mt-[1.5rem] max-w-[80rem] text-[1.6rem] leading-[2.8rem] text-[#555]">
            {currentService.mainSubHeader}
          </p>
        </div>

        {/* Services Breakdown */}
        <div className="grid grid-cols-1 gap-[2rem] sm:grid-cols-2 lg:grid-cols-3">
          {currentService.subservices.map((item, i) => (
            <div
              key={i}
              className="flex flex-col items-center justify-start gap-3 rounded-xl border border-[#e5e5e5] bg-white p-6 text-center shadow-sm transition duration-200"
            >
              <img
                src={item.icon}
                alt={item.title}
                className="h-[15rem] w-[15rem] rounded-md object-cover"
              />
              <h3 className="text-[1.8rem] font-semibold text-[#1C253C]">{item.title}</h3>
              <p className="text-[1.4rem] text-[#555]">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* Why Choose Us Section */}
        <div className="mt-[6rem] rounded-2xl bg-white p-[3rem] text-center">
          <h2 className="mb-[1.5rem] text-[2.4rem] font-[700] text-[#121212]">
            {currentService.downHeader}
          </h2>
          <p className="mx-auto max-w-[800px] text-[1.6rem] leading-[3rem] text-[#666]">
            {currentService.downSubHeader}
          </p>

          <div className="mt-[3rem] grid gap-[2rem] sm:grid-cols-2 lg:grid-cols-3">
            {currentService.whyChooseUs.map((card, index) => (
              <div
                key={index}
                className="rounded-xl border border-[#eee] bg-[#f9f9f9] p-6 transition"
              >
                <div className="text-[2.5rem]">{card.icon}</div>
                <h3 className="mt-2 text-[1.8rem] font-semibold text-[#1C253C]">{card.title}</h3>
                <p className="mt-2 text-[1.4rem] text-[#555]">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
